// Constants
import { AppRootElementId, ClientType } from "@ms/uno-constants/lib/local/AppConstants";
import { MarkerTag } from "@ms/uno-telemetry/lib/local/performance/constants/PerformanceMarkerConstants";
import { LoggingStrings } from "@ms/uno-constants/lib/local/LoggingConstants";
// Controls
import { UnoShell } from "@ms/uno-shell/lib/local/controls/unoShell/UnoShell";
import { EngagementTelemetryConstants } from "@ms/uno-constants/lib/local/EngagementTelemetryConstants";
// Factories
import { MetaOSAppActionCreatorFactory } from "../factories/MetaOSAppActionCreatorFactory";
import { MetaOSAppStoreFactory } from "../factories/MetaOSAppStoreFactory";
// HostAdaptors
import { MetaOSHostAdaptor } from "@ms/uno-hostadaptors/lib/local/metaOS/MetaOSHostAdaptor";
// Models
import { User } from "@ms/uno-models/lib/local/client/user/User";
// Telemetry
import { WebPlatformPerformanceMarker } from "@ms/uno-telemetry/lib/local/performance/WebPlatformPerformanceMarker";
// Utilities
import { getLocalStorage } from "@ms/uno-utilities/lib/local/storage/StorageUtilities";
import { ComponentLoader } from "../../utilities/loader/ComponentLoader";
import React from "react";
import * as ReactDOM from "react-dom";
import { configureHostAdaptor, loadWorkersAndRegisterTheme, setupProviders, setupWorkerLoaderAndUnoShellProps, } from "../../utilities/MetaOSAppBootstrapSetupUtils";
import { initDataPreFetcher } from "../../utilities/AppBootstrapUtils";
/**
 * The production bootstrap function
 */
export async function bootstrap() {
    // Set up performance Marker and mark bootstrap
    const performanceMarker = new WebPlatformPerformanceMarker();
    performanceMarker.mark(MarkerTag.AppBootstrap);
    const hostAdaptor = new MetaOSHostAdaptor(performanceMarker, LoggingStrings.ProductName);
    const { loggers, configProvider, context, initialRoute, initialRouteFromDeepLink, telemetryLoggers } = await configureHostAdaptor(hostAdaptor, performanceMarker);
    // Trigger the data pre-fetch
    if (configProvider().flights.EnableTriggeringMetaOSDataPreFetcherFromBootstrap) {
        initDataPreFetcher(initialRouteFromDeepLink, context, hostAdaptor, loggers, configProvider);
    }
    // Setup persistent storage
    const persistentStorage = getLocalStorage(context.userId, loggers.traceLogger, configProvider);
    // Determine engagement telemetry constant based on client type
    const clientType = configProvider().sessionMetaData.appMetadata.clientType;
    const engagementTelemetryConstant = clientType === ClientType.Office ? EngagementTelemetryConstants.OfficeApp : EngagementTelemetryConstants.MetaOSHost;
    const user = User.fromUserContext(context);
    const loader = new ComponentLoader(loggers);
    const storeFactory = new MetaOSAppStoreFactory(loader, context, user, initialRoute, loggers, persistentStorage, configProvider, initialRouteFromDeepLink != null, null);
    const { agentProviders, dispatcher, lmProviders, requestPrioritizer, serviceProviders, storeProviders } = await setupProviders(configProvider, context, engagementTelemetryConstant, initialRoute, hostAdaptor, loader, loggers, storeFactory);
    const acFactory = new MetaOSAppActionCreatorFactory(loader, dispatcher, lmProviders, storeProviders, configProvider, loggers);
    const { acProviders, unoShellProps, workerLoader, persistentAsyncStorage } = await setupWorkerLoaderAndUnoShellProps(agentProviders, context, configProvider, dispatcher, hostAdaptor, loader, loggers, lmProviders, acFactory, storeProviders, storeFactory, serviceProviders, telemetryLoggers);
    loadWorkersAndRegisterTheme(acProviders, configProvider, context, hostAdaptor, loggers, persistentAsyncStorage, requestPrioritizer, workerLoader);
    // Render the uno shell if loading the app in foreground.
    ReactDOM.render(React.createElement(UnoShell, { ...unoShellProps }), document.getElementById(AppRootElementId));
}
